module.exports = __webpack_public_path__ + "img/Locked.6c8f6649.png";